import { capitalize } from 'lodash';

import * as OrderFn from '#/features/perpetuals/trade-overview/order-functions';

import { Market } from '#/api/markets';
import { Order } from '#/api/orders';

import Title from '#/components/common/toast/Title';
import Info from '#/components/common/toast/Info';
import Buy from '#/components/common/toast/Buy';
import Sell from '#/components/common/toast/Sell';
import OrderSideIcon from '#/components/shared/OrderSideIcon';

interface Props {
  order: Order;
  market: Market;
}

export function SubmittedOrder({ order, market }: Props) {
  const icon = <OrderSideIcon side={order.side} />;

  return (
    <Info icon={icon}>
      <Title>{`${capitalize(order.type)} ${capitalize(
        order.side,
      )} Order Submitted`}</Title>
      {order.size.toFormat()} {market.base_currency}{' '}
      {order.type === 'LIMIT' && `at $${order.price.toFormat()}`}
    </Info>
  );
}

export function CancelledMarketOrder({ order }: Props) {
  const icon = <OrderSideIcon side={order.side} />;

  return (
    <Info icon={icon}>
      <Title>
        {`${capitalize(order.type)} ${capitalize(order.side)} Order Canceled`}
      </Title>
      {order.cancel_reason != null &&
        `Reason: ${formatReason(order.cancel_reason)}`}
    </Info>
  );
}

export function CancelledLimitOrder({ order, market }: Props) {
  const icon = <OrderSideIcon side={order.side} />;

  return (
    <Info icon={icon}>
      <Title>
        {`${capitalize(order.type)} ${capitalize(order.side)} Order Canceled`}
      </Title>
      {order.size.toFormat()} {market.base_currency} at $
      {order.price.toFormat()}
      <br />
      {order.cancel_reason != null &&
        `Reason: ${formatReason(order.cancel_reason)}`}
    </Info>
  );
}

export function FilledMarketOrder({ order, market }: Props) {
  const Container = order.side === 'BUY' ? Buy : Sell;

  return (
    <Container>
      <Title>{`Market ${capitalize(order.side)} Order Fill`}</Title>
      {OrderFn.filledSize(order).toFormat()} {market.base_currency}
    </Container>
  );
}

function formatReason(reason: string) {
  return capitalize(reason.replace(/_/gu, ' ').toLowerCase());
}
